import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Contagem regressiva em segundos.
 *
 * Usada no botão "Reenviar código", que a versão antiga controlava com
 * `setInterval` solto em `plano.js`. Aqui o timer é encerrado no unmount, então
 * trocar de tela no meio da contagem não deixa intervalo órfão.
 */
export function useCountdown(initialSeconds = 0) {
  const [seconds, setSeconds] = useState(initialSeconds);
  const intervalRef = useRef<number | null>(null);

  const clear = useCallback(() => {
    if (intervalRef.current !== null) {
      window.clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  const start = useCallback(
    (from: number) => {
      clear();
      setSeconds(from);
      if (from <= 0) return;

      intervalRef.current = window.setInterval(() => {
        setSeconds((current) => {
          if (current <= 1) {
            clear();
            return 0;
          }
          return current - 1;
        });
      }, 1000);
    },
    [clear]
  );

  useEffect(() => clear, [clear]);

  return { seconds, start, clear, isRunning: seconds > 0 };
}
